import { get } from '../libs/http'

export const fetchJobs = (companyId, filter) => get(`/companies/${companyId}/jobs/public`, filter)
export const fetchCompany = id => get(`/companies/${id}`)
export const fetchPlaces = placesIds => get('/places', { ids: placesIds })
export const fetchCompanyLogo = id => get(`/company-logos/${id}`)
export const fetchAccosiatedCategories = companyId => get(`/companies/${companyId}/categories`)



// WEBPACK FOOTER //
// ./src/api/index.js